import { SupportedServicesForPlayerWidget } from 'fym-common/src/utils/isSupportedUrlForPlayerWidget';
import React from 'react';
import { musicServicesByLinkType } from 'fym-shared/src/music-services/allMusicServices';
import { TypedMemo } from '../../../../../common/types';
import { musicServiceImagesByImporterId } from '../../../../../common/musicServiceImages';

const LogoServicesComponent = () => {
  return (
    <>
      {SupportedServicesForPlayerWidget.map((service) => musicServicesByLinkType[service]?.importerID)
        .filter((importerId): importerId is NonNullable<typeof importerId> => importerId !== undefined)
        .map((importerId) => {
          const sourceImporter = musicServiceImagesByImporterId[importerId];
          const ImporterLogo = sourceImporter?.logoColor.light;
          return ImporterLogo ? <ImporterLogo key={importerId} className="player-widget-icon me-3" /> : null;
        })}
    </>
  );
};

export const LogoServices = TypedMemo(LogoServicesComponent);
